var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2122 4.1773L11.1224 1.06927C11.0781 1.02468 11.0194 1.00019 10.9567 1.0002C10.8939 1.0002 10.8356 1.02469 10.7912 1.06928L8.9607 2.91084L8.95851 2.91744L8.922 2.94978L1.85172 10.0627C1.81895 10.0956 1.79679 10.1371 1.78774 10.1823L1.00506 14.0785C0.989453 14.1561 1.01349 14.2355 1.06905 14.2917C1.11337 14.336 1.17205 14.3605 1.23479 14.3605C1.25039 14.3605 1.26569 14.3589 1.28004 14.3561L5.15376 13.5682C5.19933 13.5591 5.24021 13.5368 5.27267 13.5041L14.2122 4.51044C14.2565 4.46616 14.2805 4.40682 14.2805 4.34371C14.2805 4.2806 14.2562 4.22157 14.2122 4.1773ZM4.99113 13.1208L1.53347 13.8242L2.23221 10.3455L3.25281 9.31879L6.01173 12.0943L4.99113 13.1208ZM6.34257 11.7612L3.58365 8.98596L9.09212 3.4443L11.8507 6.21952L6.34257 11.7612ZM12.1822 5.88637L9.42358 3.11115L10.9567 1.56882L13.7156 4.34404L12.1822 5.88637Z",
    fill: "#405BFF",
    stroke: "#405BFF",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEdit);
export default __webpack_public_path__ + "static/media/blue-edit.fafe97ae845631d393c6eec6ff214477.svg";
export { ForwardRef as ReactComponent };